module.exports = __webpack_public_path__ + "Images/progress-running.gif";


//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/lib/simile-timeline/timeline_js/images/progress-running.gif
// module id = 1863
// module chunks = 2